import React from 'react';
import { useSelector } from 'react-redux';
import { getSecurityUiConfig } from '../../../../base/config/functions.any';
import { isEffectiveConferenceModerator, isExternallyManagedAuthKey } from '../../../../e2ee/functions';
import Dialog from '../../../../base/ui/components/web/Dialog';
import { getConferenceState } from '../../../../base/conference/functions';
import { isInBreakoutRoom } from '../../../../breakout-rooms/functions';
import E2EESection from '../../../../e2ee/components/E2EESection';
import LobbySection from '../../../../lobby/components/web/LobbySection';
import { isEnablingLobbyAllowed } from '../../../../lobby/functions';
import PasswordSection from './PasswordSection';
/**
 * Component that renders the security options dialog.
 *
 * @returns {React$Element<any>}
 */
export default function SecurityDialog() {
    const lobbySupported = useSelector((state) => state['features/base/conference'].conference?.isLobbySupported());
    const e2eeSupported = useSelector((state) => {
        const conferenceState = getConferenceState(state);
        const { conference, e2eeSupported: storedE2eeSupported, joining } = conferenceState;
        if (typeof storedE2eeSupported === 'boolean') {
            return storedE2eeSupported;
        }
        const activeConference = conference ?? joining;
        return Boolean(activeConference?.isE2EESupported?.());
    });
    const isInBreakout = useSelector(isInBreakoutRoom);
    const disableLobbyPassword = useSelector((state) => getSecurityUiConfig(state)?.disableLobbyPassword)
        || isInBreakout;
    const isOwner = useSelector(isEffectiveConferenceModerator);
    const isExternallyManaged = useSelector((state) => isExternallyManagedAuthKey(state));
    const localE2eeEnabled = useSelector((state) => state['features/e2ee'].enabled);
    const conferenceE2eeEnabled = useSelector((state) => Boolean(getConferenceState(state).conference?.isE2EEEnabled?.()));
    const { hideLobbyButton } = useSelector(getSecurityUiConfig);
    const _isLobbyVisible = useSelector(isEnablingLobbyAllowed)
        && lobbySupported && isOwner && !isInBreakout && !hideLobbyButton;
    const showE2ee = Boolean(e2eeSupported) && (isOwner || (isExternallyManaged && (localE2eeEnabled || conferenceE2eeEnabled)));
    return (React.createElement(Dialog, { cancel: { hidden: true }, ok: { hidden: true }, titleKey: 'security.title' },
        React.createElement("div", { className: 'security-dialog' },
            _isLobbyVisible && React.createElement(LobbySection, null),
            !disableLobbyPassword && (React.createElement(React.Fragment, null,
                _isLobbyVisible && React.createElement("div", { className: 'separator-line' }),
                React.createElement(PasswordSection, null))),
            showE2ee ? React.createElement(React.Fragment, null,
                (_isLobbyVisible || !disableLobbyPassword) && React.createElement("div", { className: 'separator-line' }),
                React.createElement(E2EESection, null)) : null)));
}
